import React from "react";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";
import classNames from "classnames";

function StatusSelect({
  selectedStatus,
  statuses,
  placeholder,
  selectStatus,
}: Props) {
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.statusSelect, {
            [styles.open]: isVisible,
          })}
        >
          {selectedStatus ? (
            <div
              className={styles.status}
              style={{ borderColor: selectedStatus.color }}
              onClick={isVisible ? hide : show}
            >
              <div className={styles.group}>
                <p
                  className={styles.label}
                  style={{ color: selectedStatus.color }}
                >
                  {t(
                    `taskStatuses.${selectedStatus.label}`,
                    selectedStatus.label,
                  )}{" "}
                  {(!!selectedStatus.percentComplete ||
                    selectedStatus.percentComplete === 0) && (
                    <span
                      className={styles.completion}
                      style={{ color: selectedStatus.color }}
                    >
                      {selectedStatus.percentComplete}%
                    </span>
                  )}
                </p>
              </div>
              <ToggleArrow className={styles.icon} />
            </div>
          ) : (
            <div className={styles.status} onClick={isVisible ? hide : show}>
              <div className={styles.group}>
                <p className={styles.placeholder}>{placeholder}</p>
              </div>
              <ToggleArrow className={styles.icon} />
            </div>
          )}
          {isVisible && (
            <div
              className={styles.list}
              style={{
                borderColor: selectedStatus ? selectedStatus.color : undefined,
              }}
            >
              {statuses.map((status) => (
                <div
                  key={status.uuid}
                  className={styles.item}
                  onClick={() => {
                    selectStatus(
                      selectedStatus && selectedStatus.uuid === status.uuid
                        ? null
                        : status,
                    );
                    hide();
                  }}
                >
                  <div
                    className={styles.statusColor}
                    style={{ backgroundColor: status.color }}
                  />
                  <p className={styles.statusLabel}>
                    {t(`taskStatuses.${status.label}`, status.label)}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { StatusSelect };
